import React, { Component } from 'react'
import Chart from 'chart.js'
import { connect } from 'react-redux'

import { Colors } from '../../styles'

class ChartRanking extends Component {
  state = {
    ready: false
  }

  componentDidMount() {
    this.ctx = this.chart.getContext('2d')
    this.initChart(this.props.results)
  }

  componentWillReceiveProps({ results }){
    if(results !== this.props.results) {
      if (this.chart) this.chart.destroy()
      this.timer = setTimeout(() => {
        this.initChart(results)
      }, 200)
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  initChart = async (results) => {

    this.chart = await new Chart(this.ctx, {
      type: 'line',
      data: {
        labels: results.labels,
        datasets: [
          {
            label: '',
            data: results.scores,
            borderWidth: 4,
            borderColor: Colors.red,
            lineTension: 0,
            pointBorderWidth: 2,
            pointBorderColor: 'white',
            pointBackgroundColor: Colors.red,
            pointRadius: 6,
            backgroundColor: 'transparent',
          }
        ]
      },
      options: {
        legend: {
          display: false,
          lineWidth: 0,
          hidden: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: false,
            },
            ticks: {
              fontSize: 14,
              fontStyle: 'bold',
              fontColor: 'black',
              padding: 10,
            },
          }],
          yAxes: [
            {
              gridLines: {
                borderDash: [2, 2],
                color: Colors.darkGrey,
                zeroLineBorderDash: [2, 2],
                zeroLineColor: Colors.darkGrey,
              },
              ticks:{
                max: 1000,
                fontColor: Colors.grey,
                fontSize: 14,
                fontStyle: 'bold',
                padding: 20,
              },
              position: 'right',
            }
          ]
        },
      }
    })
  }

  render() {
    const { height, width } = this.props
    const { ready } = this.state
    return (
      <div className='chart'>
        {
          <div>
            <div className='label-charts'>Evolution</div>
            <canvas ref={ (chart) => this.chart = chart } ></canvas>
          </div>
        }
      </div>
    )
  }
}

export default connect(
  ({ Session }) => ({
    results: Session.challenge.results,
  })
)(ChartRanking)


// WEBPACK FOOTER //
// ./src/components/Challenge/ChartRanking.js